import { buildMakeUseAxios } from "@api";
import type { IOrganisation } from "@bbj-types/organisation";
import { useCallback } from "react";

export interface IGetUserResponse {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  position?: string;
  isDisabled: boolean;
  organisations: {
    organisation: { _id: string; name: string };
    roleV2: { _id: string; label: string };
    isMaster: boolean;
    teams?: { _id: string; name: string }[];
  }[];
}

const userAxiosV2 = buildMakeUseAxios(`${import.meta.env.VITE_USER_SERVICE_URL}/v2/users`);

export type TUseGetUserOrganisationBody = Pick<IOrganisation, "_id" | "name">[];

export const useGetUserOrganisation = () => {
  const [state, execute, cancel] = userAxiosV2<TUseGetUserOrganisationBody, undefined, unknown>(
    {
      url: "/organisations",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (permissions: string[]) => {
      return execute({
        params: { permissions },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export * from "./postUserFilterView";
export * from "./deleteUserFilterView";
export * from "./me";
export * from "./getUserAutocomplete";
export * from "./getUserV2";
export * from "./getUser";
export * from "./find/findUsersInternal";
export * from "./find/findUsersPartners";
export * from "./find/types";
export * from "./patchUser";
export * from "./createUser";
export * from "./patchUserMe";
